import { render, staticRenderFns } from "./RollGame.vue?vue&type=template&id=3d68b2cc&scoped=true"
import script from "./RollGame.vue?vue&type=script&lang=js"
export * from "./RollGame.vue?vue&type=script&lang=js"
import style0 from "./RollGame.vue?vue&type=style&index=0&id=3d68b2cc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d68b2cc",
  null
  
)

export default component.exports